export const STATS_CONNECTED_USER = "statsConnectedUser"
